import React from 'react';
import { PromptAgentType } from './types';
import { AgentTypeSelect } from './ChatTypeSelect';
import { SearchInput } from '../../components/common/SearchInput';

interface PromptLibraryFiltersProps {
  selectedAgentTypes: PromptAgentType[];
  onSelectedAgentTypesChange: (value: PromptAgentType[]) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  beforeSearch?: React.ReactNode;
}

export const PromptLibraryFilters: React.FC<PromptLibraryFiltersProps> = ({
  selectedAgentTypes,
  onSelectedAgentTypesChange,
  searchQuery,
  onSearchQueryChange,
  beforeSearch,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Chat Type Dropdown */}
      <AgentTypeSelect
        selectMode="multi"
        selectedValues={selectedAgentTypes}
        onSelectedValuesChange={onSelectedAgentTypesChange}
        placeholder="Assistant Type"
      />

      {beforeSearch}

      {/* Search Input */}
      <SearchInput
        value={searchQuery}
        onChange={onSearchQueryChange}
        placeholder=" Search prompts..."
        containerClassName="ml-auto w-full max-w-[400px] min-w-[260px]"
        inputClassName="placeholder-style top-heavy-input"
      />
    </div>
  );
};
